import { ChangeDetectorRef, Component, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ConfirmDialogVariant,
  ConfirmDialogComponent,
  CheckboxComponent,
} from '@core/user-interface-legacy';

interface CreateJobDialogResult {
  confirmed: boolean;
  payload: {
    dontShowAgain: boolean;
  };
}

@Component({
  selector: 'rt-confirm-create-job-dialog',
  imports: [ConfirmDialogComponent, TranslatePipe, CheckboxComponent],
  template: `
    <rt-confirm-dialog
      [title]="'app.requisitions.confirm_create_job.title' | translate"
      [message]="'app.requisitions.confirm_create_job.message' | translate"
      [agreeLabel]="'app.requisitions.confirm_create_job.agree_label' | translate"
      [cancelLabel]="'app.common.cancel' | translate"
      [variant]="ConfirmDialogVariant.Information"
      [triggerUpdateOnInit]="true"
      [isCancelable]="true"
      [closePayload]="{ payload: { dontShowAgain: this.dontShowAgain } }"
    >
      <rt-checkbox [checked]="dontShowAgain" (valueChange)="setDontShowAgain($event)" padding-top>
        <span text-weight-semi-bold>{{ 'app.common.dont_show_again' | translate }}</span>
      </rt-checkbox>
    </rt-confirm-dialog>
  `,
})
export class ConfirmCreateJobDialogComponent implements DialogComponentI<
  void,
  CreateJobDialogResult
> {
  private readonly cdRef = inject(ChangeDetectorRef);

  public ConfirmDialogVariant: typeof ConfirmDialogVariant = ConfirmDialogVariant;
  public dontShowAgain: boolean = false;

  public setDontShowAgain($event: string | boolean) {
    this.dontShowAgain = !!$event;
    this.cdRef.detectChanges();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: any, triggerUpdate: boolean): void {}
}
